import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'home', component: () => import('../views/Home.vue'), meta: { title: '首页' } },
  { path: '/brand', name: 'brand', component: () => import('../views/Brand.vue'), meta: { title: '品牌' } },
  { path: '/products', name: 'products', component: () => import('../views/Products.vue'), meta: { title: '产品' } },
  { path: '/products/:id', name: 'productDetail', component: () => import('../views/ProductDetail.vue'), meta: { title: '产品详情' } },
  { path: '/banxin', name: 'banxinBrand', component: () => import('../views/BanxinBrand.vue'), meta: { title: '版型查询' } },
  { path: '/banxin/brand/:bid', name: 'banxinSeries', component: () => import('../views/BanxinSeries.vue'), meta: { title: '车系' } },
  { path: '/banxin/series/:sid', name: 'banxinList', component: () => import('../views/BanxinList.vue'), meta: { title: '版型列表' } },
  { path: '/banxin/detail/:id', name: 'banxinDetail', component: () => import('../views/BanxinDetail.vue'), meta: { title: '版型详情' } },
  { path: '/about', name: 'about', component: () => import('../views/About.vue'), meta: { title: '企业' } }
];

const router = new VueRouter({ routes, scrollBehavior: () => ({ x: 0, y: 0 }) });

router.afterEach((to) => {
  document.title = (to.meta.title ? to.meta.title + ' - ' : '') + '雅澜瀚玥 · 整车软装';
});

export default router;
